// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterToggle-footerDrawerCloseOpenBtn-MimDI {
	position: fixed;
	text-align: center;
	-webkit-transition: all .2s linear;
	transition: all .2s linear;
	-webkit-box-shadow: 0px 7px 9px #00000029;
	        box-shadow: 0px 7px 9px #00000029;
	z-index: 9;
	color: var(--primary-foreground);
	background: var(--background-primary);
	border: 1px solid var(--background-primary);
	left: 15px;
	bottom: 15px;
	padding: 12px 24px;
	font-size: 14px;
	border-radius: 24px;
	cursor: pointer;
	outline: unset;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 5px;
}

.FooterToggle-footerCustomDrawer-Y5pqe {
	width: 100%;
	height: 350px;
	background-color: var(--footer-bg);
	overflow-y: auto;
	z-index: 8;
	position: fixed;
	left: 0px;
	right: 0px;
	bottom: -1px;
	-webkit-transition: all .2s linear;
	transition: all .2s linear;
	visibility: hidden;
	-webkit-transform: translateY(100%);
	    -ms-transform: translateY(100%);
	        transform: translateY(100%);
}

.FooterToggle-footerDrawerOpen-yREyw {
	-webkit-transform: translateY(0) !important;
	    -ms-transform: translateY(0) !important;
	        transform: translateY(0) !important;
	visibility: visible;
}

@media screen and (max-width: 767px) {
	.FooterToggle-footerDrawerCloseOpenBtn-MimDI {
		padding: 6px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/FooterToggle/FooterToggle.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,kBAAkB;CAClB,kCAA0B;CAA1B,0BAA0B;CAC1B,yCAAiC;SAAjC,iCAAiC;CACjC,UAAU;CACV,gCAAgC;CAChC,qCAAqC;CACrC,2CAA2C;CAC3C,UAAU;CACV,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,aAAa;CACb,kCAAkC;CAClC,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,SAAS;CACT,UAAU;CACV,YAAY;CACZ,kCAA0B;CAA1B,0BAA0B;CAC1B,kBAAkB;CAClB,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC,2CAAmC;KAAnC,uCAAmC;SAAnC,mCAAmC;CACnC,mBAAmB;AACpB;;AAEA;CACC;EACC,YAAY;CACb;AACD","sourcesContent":[".footerDrawerCloseOpenBtn {\n\tposition: fixed;\n\ttext-align: center;\n\ttransition: all .2s linear;\n\tbox-shadow: 0px 7px 9px #00000029;\n\tz-index: 9;\n\tcolor: var(--primary-foreground);\n\tbackground: var(--background-primary);\n\tborder: 1px solid var(--background-primary);\n\tleft: 15px;\n\tbottom: 15px;\n\tpadding: 12px 24px;\n\tfont-size: 14px;\n\tborder-radius: 24px;\n\tcursor: pointer;\n\toutline: unset;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 5px;\n}\n\n.footerCustomDrawer {\n\twidth: 100%;\n\theight: 350px;\n\tbackground-color: var(--footer-bg);\n\toverflow-y: auto;\n\tz-index: 8;\n\tposition: fixed;\n\tleft: 0px;\n\tright: 0px;\n\tbottom: -1px;\n\ttransition: all .2s linear;\n\tvisibility: hidden;\n\ttransform: translateY(100%);\n}\n\n.footerDrawerOpen {\n\ttransform: translateY(0) !important;\n\tvisibility: visible;\n}\n\n@media screen and (max-width: 767px) {\n\t.footerDrawerCloseOpenBtn {\n\t\tpadding: 6px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerDrawerCloseOpenBtn": `FooterToggle-footerDrawerCloseOpenBtn-MimDI`,
	"footerCustomDrawer": `FooterToggle-footerCustomDrawer-Y5pqe`,
	"footerDrawerOpen": `FooterToggle-footerDrawerOpen-yREyw`
};
module.exports = ___CSS_LOADER_EXPORT___;
